import React, { useCallback, useMemo } from 'react';
import Accordion from 'components/Accordion';
import Searcher from 'components/DesignSystem/Searcher';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useSearchFilter from 'hooks/useSearchFilter';
import Snackbar from 'components/DesignSystem/Snackbar';
import RadioButton from 'components/DesignSystem/RadioButton';
import useLocationOptions from 'hooks/Meteorology/Agro/CultureIndex/Location/useLocationOptions';

export default function Location() {
  const {
    availableLocations,
    selectedLocationId,
    setLocation,
  } = useLocationOptions();
  const closeAccordion = useMemo(
    () => buildAccordionClickFunction('culture-index-location-location'),
    [],
  );
  const setLocationAndClose = useCallback((newLocation : number) => {
    setLocation(newLocation);
    closeAccordion();
  }, [setLocation, closeAccordion]);
  const { searchTerm, onSearchChange, searchIncludes } = useSearchFilter();
  const filteredLocations = useMemo(() => (
    availableLocations?.filter((location) => searchIncludes(location.name))
  ), [availableLocations, searchIncludes]);

  return (
    <Accordion.Item eventKey="location" id="culture-index-location-location">
      <Accordion.Header>Local</Accordion.Header>
      <Accordion.Body>
        <Searcher
          value={searchTerm}
          onChange={onSearchChange}
        />
        {availableLocations.length === 0 && (
          <Snackbar className="mt-2">
            Nenhum local disponível para o grupo selecionado
          </Snackbar>
        )}
        {filteredLocations.map((location) => (
          <RadioButton
            key={location.id}
            label={location.name}
            checked={location.id === selectedLocationId}
            onChange={() => setLocationAndClose(location.id)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
